import React from 'react';

const context = React.createContext();

export const DocumentsViewPageProvider = context.Provider;
export const DocumentsViewPageConsumer = context.Consumer;
